import type { TimeSlot } from './../../../cart/domain/Cart';
export interface DeliveryChildItemDto {
  id: string;
  itemId: string;
  sellerId: string;
  quantity: {
    unitOfMeasure: string;
    value: number;
  };
}

export interface DeliveryItemDto {
  id: string;
  itemId: string; // Product SKU
  sellerId: string;
  classsification: string;
  quantity: {
    unitOfMeasure: string;
    value: number;
  };
  size: string;
  childItems?: DeliveryChildItemDto[];
}

export interface TimeSlotDto {
  name: 'AM1' | 'TH' | 'PM1' | 'PM2';
  deliveryTimeStart: string;
  deliveryTimeEnd: string;
}

export interface ShippingOptionDto {
  selected: boolean;
  shippingType: 'COLLECT' | 'DELIVERY';
  shippingSubType?: 'HOME' | 'IN_STORE' | 'COPEC';
  shippingMethod:
    | 'SCHEDULED'
    | 'NEXT_DAY'
    | 'SAME_DAY'
    | 'DATE_RANGE'
    | 'SCHEDULED_DEFERRED';
  classification?: string;
  logisticsModel: string;
  shipmentCostTotal: string;
  shipmentCostBase: string;
  shipmentCostCurrency?: string;
}

export interface GeneralDeliveryOptionDto {
  deliveryDateFrom: string;
  deliveryDateTo: string;
  shipDate: string;
  timeSlots?: TimeSlotDto[];
  collectNodeCode?: string;
}

export interface CollectNodeAddressDto {
  collectNodeAddress1?: string;
  collectNodeAddress2?: string;
  collectRegionCode?: string;
  collectRegionName?: string;
  collectComunaCode?: string;
  collectComunaName?: string;
  uniqueReferences: {
    collectComunaEOM?: string;
  };
}

export enum ECollectNodeAdmin {
  PARIS = 'PARIS',
  EASY = 'EASY',
  JUMBO = 'JUMBO',
  SANTA_ISABEL = 'SANTA_ISABEL',
  COPEC = 'COPEC'
}

export interface GeneralCollectOptionDto extends GeneralDeliveryOptionDto {
  originNodeType?: 'PROVIDER' | 'WAREHOUSE' | 'STORE' | 'SELLER';
  originNodeCode?: string;
  originNodeAdmin?: string;
  shippingCapability?:
    | 'HOME_DELIVERY'
    | 'CLICK_AND_COLLECT'
    | 'BOPIS'
    | 'SHIP_FROM_STORE'
    | 'PUNTO_RETIRO'
    | 'CROSSDOCK';
  collectNodeType?: 'PROVIDER' | 'WAREHOUSE' | 'STORE' | 'SELLER';
  collectNodeCode?: string;
  collectNodeAdmin?: ECollectNodeAdmin;
  collectNodeName?: string;
  rank: number;
  collectNodeAddress?: CollectNodeAddressDto;
}

export interface GeneralDeliveryShippingOptionDto extends ShippingOptionDto {
  shippingCapability?:
    | 'HOME_DELIVERY'
    | 'CLICK_AND_COLLECT'
    | 'BOPIS'
    | 'SHIP_FROM_STORE';
  originNodeType?: 'PROVIDER' | 'WAREHOUSE' | 'STORE' | 'SELLER';
  originNodeCode?: string;
  originNodeAdmin?: string;
  options: GeneralDeliveryOptionDto[];
}

export interface GeneralCollectShippingOptionDto extends ShippingOptionDto {
  originNodeType?: 'PROVIDER' | 'WAREHOUSE' | 'STORE' | 'SELLER';
  originNodeCode?: string;
  originNodeAdmin?: string;
  options: GeneralCollectOptionDto[];
}

export interface DeliveryGroupDto {
  id: string;
  classificationGroup: string;
  items: DeliveryItemDto[];
  shippingOptions:
    | GeneralDeliveryShippingOptionDto[]
    | GeneralCollectShippingOptionDto[];
  classificationGroupMeta?: ClassificationGroupMetaDto;
}

export interface ClassificationGroupMetaDto {
  sellerTypeIndex: '1P' | '3P';
  sellerNameIndex: string;
  productClassificationIndex: string;
  shippingTypeIndex: 'COLLECT' | 'DELIVERY';
  shippingSubTypeIndex: 'HOME' | 'IN_STORE' | 'COPEC';
  shippingMethodIndex:
    | 'SCHEDULED'
    | 'NEXT_DAY'
    | 'SAME_DAY'
    | 'DATE_RANGE'
    | 'SCHEDULED_DEFERRED';
  originNodeCodeIndex?: string;
  timeSlotIndex?: 'AM1' | 'PM1' | 'PM2';
  deliveryDateFromIndex?: string;
  deliveryDateToIndex?: string;
  originNodeNameIndex?: string;
}

export interface HttpShippingMethodDto {
  deliveryGroups: DeliveryGroupDto[];
  unavailable: Unavailable[];
}

export interface Unavailable {
  itemId: string;
  quantity: number;
  sellerId: string;
  status: {
    code: number;
    description: string;
  };
}

export interface HttpShippingMethodResponse {
  data: HttpShippingMethodDto;
  status: number;
}

export interface HttpShippingMethodOptionDraft {
  shipDate: string;
  originNodeType?: 'PROVIDER' | 'WAREHOUSE' | 'STORE' | 'SELLER';
  originNodeCode?: string;
  collectNodeCode?: string;
  timeSlot?: TimeSlot;
}

export interface HttpShippingMethodDraft {
  deliveryGroupId: string;
  shippingType: 'COLLECT' | 'DELIVERY';
  shippingSubType?: 'HOME' | 'IN_STORE' | 'COPEC';
  shippingMethod?:
    | 'SCHEDULED'
    | 'NEXT_DAY'
    | 'SAME_DAY'
    | 'DATE_RANGE'
    | 'SCHEDULED_DEFERRED';
  option: HttpShippingMethodOptionDraft;
}

export interface HttpShippingOptionDraft {
  id?: string;
  shipDate?: string;
  timeSlot?: TimeSlot;
  collectNodeCode?: string;
  originNodeCode?: string;
  originNodeType?: string;
}

export interface HttpClientPreferenceParams {
  shippingType?: string;
  shippingSubType?: string;
  shippingMethod?: string;
  deliveryDateFrom?: string;
  deliveryDateTo?: string;
  nodeCode?: string;
  collectRegionCode?: string;
  timeSlot?: string;
}
